import React from "react";
import { Card, Typography } from "@mui/material";

export default function Court(props: { court: any; type: string,tieDescription?:string }) {
  return (
    <div className="mx-1 mb-3">
      <Card
        className="border-solid border-1 rounded-none"
        style={{
          ...styles.root,
          height: props.type === "teams" ? 42 : 25, 
        }}
      >
        <Typography style={styles.text}>
          {props.court}
          {props.type === "teams" && <br />}
          {props.type === "teams" && props.tieDescription}
        </Typography>
      </Card>
    </div>
  );
}

const styles = {
  root: {
    borderStyle: "ridge",
    display: "flex",
    backgroundColor: "#4a5db5",
    alignItems: "center",
    justifyContent: "center",
  },
  text: {
    fontSize: 12,
    color: "white",
    textAlign: "center",
  },
} as const;
